import { apiClient } from "./apiClient";

export const themeApi = {
  get: () => apiClient.get("/user/theme").then((r) => r.data),
  update: (themeName) => apiClient.put("/user/theme", { theme_name: themeName }).then((r) => r.data),
  getFeatures: () => apiClient.get("/user/theme/features").then((r) => r.data),
  updateFeatures: (toggles) => apiClient.put("/user/theme/features", { toggles }).then((r) => r.data),
  getAvailableFeatures: () => apiClient.get("/user/theme/available-features").then((r) => r.data),
  /* "I'll decide later" is still an ANSWER (#487) -- it records the tier
     the nudge was shown for, so the same upgrade does not ask twice. */
  /* What to SEE while helping in the account being worked in (#508).
     null clears it: everything the account has. */
  setHelperTheme: (themeName) =>
    apiClient.put("/user/theme/helper", { theme_name: themeName || null }).then((r) => r.data),
  answerNudge: () => apiClient.post("/user/theme/nudge").then((r) => r.data),
  /* Preview features (#378): a PERSON's choice, off by default. */
  setPreviewOptIn: (optedIn) =>
    apiClient.put("/user/preview-opt-in", { opted_in: optedIn }).then((r) => r.data),
  /* Feedback has its own path; it is read, not individually answered. */
  sendPreviewFeedback: (featureName, message) =>
    apiClient.post("/user/preview-feedback", { feature_name: featureName, message }).then((r) => r.data),
};

export const userApi = {
  // How many days after a check a hive is flagged (V034, #207). Ungated --
  // knowing when your own hives are due is not a paid feature.
  getInspectionInterval: () => apiClient.get("/user/inspection-interval").then((r) => r.data),
  /*
   * #377: the two cadences travel together.
   *
   * `days` stays the first positional argument so every existing caller
   * is unchanged.
   *
   * THE SEASON DATE IS NO LONGER SENT FROM HERE. It was an account-level
   * "close every hive until this date", which V100 replaced with a date
   * per hive (hivesApi.setSeason / hives/season) because migratory
   * keepers shut half an operation and work the rest. The endpoint still
   * ACCEPTS season_closed_until and clear_season, so an older build in
   * somebody's pocket keeps working; nothing here sends them, and
   * app.Users.season_closed_until is now read by nothing at all.
   */
  setInspectionInterval: (days, { closedIntervalDays } = {}) =>
    apiClient.put("/user/inspection-interval", {
      interval_days: days,
      closed_interval_days: closedIntervalDays,
    }).then((r) => r.data),
};

export const subscriptionApi = {
  get: () => apiClient.get("/user/subscription").then((r) => r.data),
  update: (newTier, paymentId) => apiClient.put("/user/subscription", { new_tier: newTier, payment_id: paymentId }).then((r) => r.data),
  plans: () => apiClient.get("/user/subscription/plans").then((r) => r.data),
};

/**
 * Each app can say the other exists (#302).
 *
 * `appSeen` is a breadcrumb, not a feature: called once at startup so the
 * OTHER app knows whether this one has ever been opened. Without it the
 * reminder cannot tell a first-timer from somebody who works on both
 * every day, and nagging the second kind is how a prompt gets
 * permanently dismissed.
 *
 * All three are best-effort at every call site. A prompt nobody asked for
 * must never be the reason a dashboard fails to load.
 *
 * Its own export, matching mobile, so the two files read the same.
 */
export const otherAppApi = {
  appSeen: (app) => apiClient.post("/user/app-seen", { app }).then((r) => r.data),
  /* `check`, not `prompt`. The browser has a global prompt() this
     codebase bans outright (#328), and noBrowserDialogs greps for the
     bare word -- so a method called prompt() is both a false positive on
     that guard forever and a name that reads like the thing it forbids. */
  check: (app) => apiClient
    .get("/user/other-app-prompt", { params: { app } })
    .then((r) => r.data),
  dismiss: (app) => apiClient
    .post("/user/other-app-prompt/dismiss", { app })
    .then((r) => r.data),
};
